import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const WeighBridge = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Weighbridge
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>
      <div className="mt-40 flex items-center justify-center gap-20">
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/WEIGHBRIDGEIN");
          }}
        >
          {/* <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {ListOfVehiclesPendingGateInwardsCounter}
          </div> */}

          <h3>WeighBridge Inwards</h3>
        </div>
        {/* <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/WEIGHBRIDGEOUT");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {ListOfVehiclesPendingGateInwardsCounter}
          </div>

          <h3>WeighBridge Outwards</h3>
        </div> */}
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/SUCCEEDINGWEIGHBRIDGES");
          }}
        >
          {/* <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {ListOfVehiclesPendingGateInwardsCounter}
          </div> */}

          <h3>Succeeding WeighBridges</h3>
        </div>
      </div>
    </div>
  );
};

export default WeighBridge;
